import { Injectable } from '@angular/core';
import { interval } from 'rxjs/internal/observable/interval';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
	providedIn: 'root',
})
export class OcrTimerManagerService {
	public totalTime: number = 0;
	public manualTime: number = 0;
	public warningTime: number = 0;
	public blurSeconds: number = 0;
	public centerSeconds: number = 0;
	public documentCategorySeconds: number = 0;

	private subsTotalTime: Subscription;
	private subsManualTime: Subscription;
	private subsWarningTime: Subscription;
	private subsDocumentCategoryTime: Subscription;

	// Total Time
	public startTotalTime(): void {
		if (!this.subsTotalTime) {
			this.subsTotalTime = this.createTimer(() => this.totalTime++);
		}
	}
	public stopTotalTime(): void {
		if (this.subsTotalTime) {
			this.subsTotalTime.unsubscribe();
			this.subsTotalTime = null;
		}
	}
	public resetTotalTime(): void {
		this.totalTime = 0;
	}

	// Manual Time
	public startManualTime(fn: () => void): void {
		if (!this.subsManualTime) {
			this.subsManualTime = this.createTimer(() => {
				this.manualTime++;
				fn();
			});
		}
	}
	public stopManualTime(): void {
		if (this.subsManualTime) {
			this.subsManualTime.unsubscribe();
			this.subsManualTime = null;
		}
		this.manualTime = 0;
	}

	// Warning Time
	public startWarningTime(fn: () => void): void {
		if (!this.subsWarningTime) {
			this.subsWarningTime = this.createTimer(() => {
				this.warningTime++;
				fn();
			});
		}
	}
	public stopWarningTime(): void {
		if (this.subsWarningTime) {
			this.subsWarningTime.unsubscribe();
			this.subsWarningTime = null;
		}
		this.warningTime = 0;
	}

	// Stop all timers
	public stopAllTimers(): void {
		this.stopWarningTime();
	}

	// Utilidad para crear timer
	private createTimer(callback: () => void): Subscription {
		// Usar timer de RxJS para incrementar cada segundo
		return interval(1000).subscribe(callback);
	}
}
